import PropTypes from "prop-types";
import {
  Sankey,
  Tooltip,
  ResponsiveContainer,
  Rectangle,
  Layer,
} from "recharts";

import { classNames } from "primereact/utils";

function CustomNode({
  x,
  y,
  width,
  height,
  index,
  payload,
  containerWidth,
  xyLabelColor,
}) {
  const isOut = x + width + 6 > containerWidth;

  return (
    <Layer key={`CustomNode${index}`}>
      <Rectangle
        x={x}
        y={y}
        width={width}
        height={height}
        fill="#5192ca"
        fillOpacity="1"
      />
      <text
        textAnchor={isOut ? "end" : "start"}
        x={isOut ? x - 6 : x + width + 6}
        y={y + height / 2}
        fontSize="14"
        fill={xyLabelColor}
      >
        {payload.name}
      </text>
      <text
        textAnchor={isOut ? "end" : "start"}
        x={isOut ? x - 6 : x + width + 6}
        y={y + height / 2 + 15}
        fontSize="12"
        fill={xyLabelColor}
        strokeOpacity="0.5"
      >
        {`${payload.value}k`}
      </text>
    </Layer>
  );
}

function CustomLink({
  sourceX,
  targetX,
  sourceY,
  targetY,
  sourceControlX,
  targetControlX,
  linkWidth,
  index,
  payload,
}) {
  return (
    <Layer key={`CustomLink${index}`}>
      <path
        d={`
          M${sourceX},${sourceY + linkWidth / 2}
          C${sourceControlX},${sourceY + linkWidth / 2}
            ${targetControlX},${targetY + linkWidth / 2}
            ${targetX},${targetY + linkWidth / 2}
          L${targetX},${targetY - linkWidth / 2}
          C${targetControlX},${targetY - linkWidth / 2}
            ${sourceControlX},${sourceY - linkWidth / 2}
            ${sourceX},${sourceY - linkWidth / 2}
          Z
        `}
        fill={payload.bgColor}
        strokeWidth="0"
        fillOpacity={0.6}
      />
    </Layer>
  );
}

export default function ModuleChartSankey({
  className = "",
  styles = {},
  data = { nodes: [], links: [] },
  options = {},
}) {
  const {
    xyLabelColor = "#a3a3a3",
    margin = {
      top: 0,
      right: 60,
      left: 10,
      bottom: 0,
    },
  } = options;

  return (
    <div className={classNames("inline-block", className)} style={styles}>
      <ResponsiveContainer width="100%" height="100%">
        <Sankey
          width={800}
          height={500}
          data={data}
          nodePadding={30}
          margin={margin}
          link={<CustomLink />}
          node={<CustomNode xyLabelColor={xyLabelColor} />}
        >
          <Tooltip />
        </Sankey>
      </ResponsiveContainer>
    </div>
  );
}

const sankeyPayloadShape = PropTypes.shape({
  name: PropTypes.string,
  value: PropTypes.number,
  bgColor: PropTypes.string,
});

CustomNode.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  index: PropTypes.number,
  payload: sankeyPayloadShape,
  containerWidth: PropTypes.number,
  xyLabelColor: PropTypes.string,
};

CustomLink.propTypes = {
  sourceX: PropTypes.number,
  targetX: PropTypes.number,
  sourceY: PropTypes.number,
  targetY: PropTypes.number,
  sourceControlX: PropTypes.number,
  targetControlX: PropTypes.number,
  linkWidth: PropTypes.number,
  index: PropTypes.number,
  payload: sankeyPayloadShape,
};

ModuleChartSankey.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  data: PropTypes.shape({
    nodes: PropTypes.arrayOf(PropTypes.object),
    links: PropTypes.arrayOf(PropTypes.object),
  }),
  options: PropTypes.shape({
    xyLabelColor: PropTypes.string,
    margin: PropTypes.object,
  }),
};
